import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import createCurrentTimeStream from './createCurrentTimeStream';
import createMaxTimeStream from './createMaxTimeStream';
import createEndedStream from './createEndedStream';
import createUiHiddenStream from './createUiHiddenStream';
import createIsLiveStream from './createIsLiveStream';
import createFullscreenStream from './createFullscreenStream';

const createLegacyShimStream = (
    frameUpdate$,
    mediaUpdate$,
    playbackUpdate$,
    errors$,
) => {
    const currentTime$ = createCurrentTimeStream(playbackUpdate$);
    const ended$ = createEndedStream(playbackUpdate$);
    const fullscreen$ = createFullscreenStream(frameUpdate$);
    const isLive$ = createIsLiveStream(mediaUpdate$);
    const maxTime$ = createMaxTimeStream(playbackUpdate$);
    const uiHidden$ = createUiHiddenStream(frameUpdate$);

    return combineLatest(
        currentTime$,
        ended$,
        errors$,
        fullscreen$,
        isLive$,
        maxTime$,
        uiHidden$,
    )
        .pipe(
            map(([currentTime, ended, errors, fullscreen, isLive, maxTime, uiHidden]) => ({
                currentTime,
                ended,
                errors,
                fullscreen,
                isLive,
                maxTime,
                playerInteractions: null,
                uiHidden,
            }))
        );
};

export default createLegacyShimStream;
